/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.banners.internal

import features.banners.models.BannersModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.banners.internal.BannersUseCase.Params

internal class BannersUseCase : AsyncUseCase<BannersModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val bannersService: BannersService = BannersServiceImpl()

    override suspend fun run(params: Params): Result<BannersModel> {
        return bannersService.getBanners(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
